import { jsx as _jsx } from "react/jsx-runtime";
export function Toggle({ checked, onChange, disabled, className, 'aria-label': ariaLabel }) {
    return (_jsx("button", { type: "button", role: "switch", "aria-checked": checked, "aria-label": ariaLabel, disabled: disabled, onClick: onChange, className: className ? `oq-toggle ${className}` : 'oq-toggle', children: _jsx("span", { className: "oq-toggle__thumb", "aria-hidden": "true" }) }));
}
//# sourceMappingURL=Toggle.js.map